import { useState, useEffect } from 'react';
import { adminApi } from '../../lib/api';
import toast from 'react-hot-toast';

export default function AdminVehiclesPage() {
  const [vehicles, setVehicles] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [notes, setNotes] = useState('');

  const load = () => {
    setLoading(true);
    adminApi.pendingVehicles().then((res: any) => {
      setVehicles(res.vehicles);
      setLoading(false);
    }).catch(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const approve = async (id: string) => {
    try {
      await adminApi.approveVehicle(id, notes);
      toast.success('승인되었습니다');
      setNotes('');
      load();
    } catch (err: any) {
      toast.error(err.message);
    }
  };

  const reject = async (id: string) => {
    const reason = prompt('거절 사유를 입력하세요:');
    if (!reason) return;
    try {
      await adminApi.rejectVehicle(id, reason);
      toast.success('거절되었습니다');
      load();
    } catch (err: any) {
      toast.error(err.message);
    }
  };

  if (loading) {
    return <div className="flex justify-center py-20"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-600" /></div>;
  }

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">차량 승인 관리</h1>

      {vehicles.length === 0 ? (
        <div className="card p- overflow-x-auto8 text-center text-gray-400">승인 대기 중인 차량이 없습니다</div>
      ) : (
        <div className="space-y-4">
          {vehicles.map((v: any) => (
            <div key={v.id} className="card p- overflow-x-auto5">
              <div className="flex items-start justify-between">
                <div>
                  <h3 className="font-semibold text-lg">{v.make} {v.model} ({v.year})</h3>
                  <p className="text-sm text-gray-500 mt-1">차주: {v.owner_name} ({v.owner_email})</p>
                  <p className="text-sm text-gray-500">
                    {v.location_city} · {v.vehicle_type} · {v.category === 'prop_car' ? '소품차' : '렌트카'} · {new Intl.NumberFormat('ko-KR').format(v.daily_rate)}원/일
                  </p>
                  {v.description && <p className="text-sm text-gray-600 mt-2">{v.description}</p>}
                </div>
                <div className="flex gap-2">
                  <button onClick={() => approve(v.id)} className="btn-primary text-sm py-1.5 px-3">승인</button>
                  <button onClick={() => reject(v.id)} className="btn-danger text-sm py-1.5 px-3">거절</button>
                </div>
              </div>
              <div className="mt-3">
                <input
                  type="text"
                  className="input-field text-sm"
                  placeholder="승인/거절 메모 (선택사항)"
                  value={notes}
                  onChange={e => setNotes(e.target.value)}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
